/**
 * The last few things that changed who the page thinks is signed in: auth
 * events, local sign-outs and the tab hiding or showing. Read when a page
 * shown to a signed-in person reads as signed out while the session is still
 * stored, so the report says what came just before (designer-remount, the
 * /auth round trips of 16-19.10 on Android and Windows alike).
 */
const MAX = 12;
const trail: Array<{ what: string; session?: boolean; at: number }> = [];

export function noteAuth(what: string, session?: boolean): void {
  trail.push({ what, ...(session === undefined ? {} : { session }), at: Date.now() });
  if (trail.length > MAX) trail.splice(0, trail.length - MAX);
}

/** Newest last, each with how long ago it happened. */
export function authTrail(): Array<{ what: string; session?: boolean; agoMs: number }> {
  const now = Date.now();
  return trail.map(({ at, ...rest }) => ({ ...rest, agoMs: now - at }));
}

if (typeof document !== 'undefined') {
  document.addEventListener('visibilitychange', () => noteAuth(`tab-${document.visibilityState}`));
}
